import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../ui/paragraph';

export function AttributeSelect({
  attribute,
  updateVariantValues,
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
}) {
  const attrId = attribute.id;
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const selectedValue = valueAttribute?.values[0];
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  const handleClick = (clicked: ValuesEntity) => {
    if (clicked.id === selectedValue) {
      setFilter({ attributes: filter.filter(item => item.id !== attrId) });
      updateVariantValues(attribute, clicked);
    } else {
      setFilter({ selectedValue: { attribute, value: clicked }, replace: true });
      updateVariantValues(attribute, clicked);
    }
  };

  return (
    <div className="grid w-full grid-cols-2 gap-4 md:gap-3">
      {sortedValues.map(v => {
        const isActive = v.id === selectedValue;

        return (
          <button
            key={v.id}
            onClick={() => handleClick(v)}
            className={cn(
              'col-span-1 flex w-full items-center justify-between rounded-[4px] border border-border p-3 transition-all',
              isActive && 'border-primary bg-primary-foreground',
            )}
          >
            <Paragraph size="base" color="black" className="font-bold">
              {v.name}
            </Paragraph>
          </button>
        );
      })}
    </div>
  );
}
